export default __webpack_public_path__ + "static/support-0954910cb546bc27863637d6999ab341.svg";